'use client'
import React, { useState, useEffect, useRef } from 'react'
import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { AiOutlineLayout } from "react-icons/ai"
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import CurrencySymbol from '@components/CurrencySymbol'
import LinkComponent from '@components/LinkComponent'

import tailwindConfig from '@tailwind.config'


const MobileMapPropertyCard = ({ property, imageWidth = 150, imageHeight = 80, includeInactive = false, newLimit, isLast, district = undefined, dictionary, lang }) => {
    const style = {
        // color: tailwindConfig.theme.extend.colors.secondary,
        // height: 65,
        // overflow: 'hidden',
        // z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(property.isLiked)
    const { data: session } = useSession()

    const cardRef = useRef();



    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    return (
        <div ref={cardRef} className={`relative sm:w-[${imageWidth}px] w-full p-2 `}>
            <LinkComponent
                href={'/properties/' + property.slug}
                className='border-forth border-[1px] border-solid'
            >
                <div className='flex flex-col bg-light rounded-md'>
                    <div className='flex flex-row'>
                        <div className='relative w-[170px]'>
                            <Image
                                placeholder="blur"
                                blurDataURL={property.blur}
                                className='w-[170px] rounded-md'
                                src={property.cover}
                                width={imageWidth}
                                height={imageHeight}
                                alt={property.slug}
                            />
                            {property.isPromotion ? (
                                <div className='absolute top-1 bg-third text-light px-1 text-sm rounded-r-md z-10 font-semibold'>{property.promotionTitle}</div>
                            ) : null
                            }
                        </div>
                        <div className='w-full p-1' >
                            <div width={imageWidth} className='text-sm font-semibold text-maincolor relative flex flex-col justify-between overflow-hidden h-[40px]' title={property.name}>
                                <h2>
                                    {property.name}
                                </h2>

                                <div className='sm:absolute z-40 right-0 left-0 bottom-0 sm:h-[30px] h-0 bg-gradient-to-b from-transparent to-light'></div>

                            </div>
                            {/* <div className='text-sm font-semibold text-third'><CurrencySymbol lang={lang} />{property.price}{property.saleType === 'rent' ? `${dictionary.month}` : ''}</div> */}
                            {property.salePrice !== undefined && (
                                <div className='text-sm font-semibold text-third'><CurrencySymbol lang={lang} />{property.salePrice}</div>
                            )}
                            {property.rentPrice !== undefined && (
                                <div className='text-sm font-semibold text-third'><CurrencySymbol lang={lang} />{property.rentPrice}{`/${dictionary.month}`}</div>
                            )}
                            {property.category == 'Land' ? (
                                <div className='flex flex-row'>
                                    <div className='flex flex-row items-center'>
                                        <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary?.sqm}</span>
                                        <AiOutlineLayout
                                            color={tailwindConfig.theme.extend.colors.secondary}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className='flex flex-row'>
                                    {(property.bedrooms && property.bedrooms > 0) &&
                                        <div className='flex flex-row items-center mr-2'>
                                            <span className='mr-1 text-maincolor'>{property.bedrooms}</span>
                                            <BiSolidBed
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                            />
                                        </div>
                                    }
                                    {(property.bathrooms && property.bathrooms > 0) &&
                                        <div className='flex flex-row items-center mr-2'>
                                            <span className='mr-1 text-maincolor'>{property.bathrooms}</span>
                                            <BiSolidBath
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                            />
                                        </div>
                                    }
                                    {(property.livingArea && property.livingArea > 0) &&
                                        <div className='flex flex-row items-center'>
                                            <span className='mr-1 text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                                            <AiOutlineLayout
                                                color={tailwindConfig.theme.extend.colors.secondary}
                                            />
                                        </div>
                                    }
                                </div>
                            )}
                        </div>
                    </div>
                    {property.publicTransport ? (
                        <div className='flex flex-row flex-wrap my-1'>
                            {property.publicTransport.map((transport, index) => (
                                <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-[1px] mb-[1px]`}>{transport.type.toUpperCase()} {transport.transportName?.[lang] ? transport.transportName[lang] : transport.stationName}</div>
                            ))}
                        </div>
                    ) : null}

                </div>
            </LinkComponent >
        </div>
    )
}

export default MobileMapPropertyCard